import { getEnv } from '@/lib/env';

// Nom du cookie de session Supabase — DOIT être identique côté navigateur et
// côté serveur.
//
// Par défaut, supabase-js dérive ce nom du hostname de l'URL qu'on lui passe
// (`sb-<premier-label>-auth-token`). Or les deux côtés ne visent pas la même
// URL : le navigateur parle à `api.dev.mindexia.fr` tandis que le serveur
// passe par le gateway interne `kong:8000` (→ `sb-kong-auth-token`). Deux
// noms = la session et le `code_verifier` PKCE écrits par un côté sont
// invisibles pour l'autre : le callback SSO ne retrouvait plus son verifier
// et repartait en `/login?error=exchange`.
//
// On fige donc le nom sur l'URL PUBLIQUE, la seule connue des deux côtés.
//
// Instance non prod : le nom porte AUSSI le label d'instance
// (`api.dev.mindexia.fr` → `sb-api-dev-auth-token`). Dev et prod sont servis
// sur le même hôte Tailscale (observatoire des moteurs, ports 3003 et 3004) :
// un navigateur ne sépare pas les cookies par port, donc avec un nom commun,
// se connecter sur l'un écrasait la session de l'autre. La prod
// (`api.mindexia.fr`, trois labels) garde `sb-api-auth-token` : aucune session
// utilisateur réelle n'est invalidée. Détail : docs/engine-observatory.md.
export function supabaseAuthCookieName(): string {
  const { hostname } = new URL(getEnv().NEXT_PUBLIC_SUPABASE_URL);
  const labels = hostname.split('.');
  const suffix = labels.length >= 4 ? `${labels[0]}-${labels[1]}` : labels[0];
  return `sb-${suffix}-auth-token`;
}
